<cigna-omni-conversation-summary-card
  *ngFor="
    let item of summaryCardList$ | async;
    trackBy: trackByFunc;
    index as i
  "
  [attr.data-omni-qa-summary-card-conversation-newMessages]="item.newMessages"
  [attr.data-omni-qa-summary-card-conversation-state]="item.state"
  [attr.data-omni-qa-summary-card-conversationId]="item.conversationId"
  [attr.data-omni-qa-summary-card-index]="i"
  [body]="item.body"
  [chevronColor]="item.chevronColor"
  [conversationId]="item.conversationId"
  [date]="item.date"
  [icon]="item.icon"
  [iconColors]="item.iconColors"
  [iconData]="item.iconData"
  [isClosed]="item.isClosed"
  [newMessages]="item.newMessages"
  [subject]="item.subject"
  [state]="item.state"
  [context]="item.context"
></cigna-omni-conversation-summary-card>
